import { JsonParser } from '@1inch-community/core/storage';
import { getChainIdList, getWalletExplorerUrl } from '@1inch-community/sdk/chain';
import { BehaviorSubject, defer, distinctUntilChanged, filter, switchMap } from 'rxjs';
export class WalletAccountContext {
    constructor(wallet, tokenStorage, persistSyncStorage) {
        this.wallet = wallet;
        this.tokenStorage = tokenStorage;
        this.persistSyncStorage = persistSyncStorage;
        this.connectedWalletInfo$ = defer(() => this.wallet.data.info$);
        this.connectedWalletAddress$ = defer(() => this.wallet.data.activeAddress$);
        this.chainId$ = defer(() => this.wallet.data.chainId$);
        this.walletBalance$ = this.connectedWalletAddress$.pipe(distinctUntilChanged(), filter((address) => address !== null), switchMap((address) => this.tokenStorage.getCrossChainTotalFiatBalance({ walletAddress: address, chainIds: null })));
        this.chainFilter$ = new BehaviorSubject([]);
        const chainFilter = persistSyncStorage.get('inch-select-token_chain-filter', JsonParser) ??
            getChainIdList();
        this.chainFilter$.next(chainFilter);
    }
    copyAddress(walletAddress) {
        navigator.clipboard.writeText(walletAddress.toString()).catch((e) => console.warn(e));
    }
    openExplorer(chainId, walletAddress) {
        const url = getWalletExplorerUrl(chainId, walletAddress);
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }
    onChangeChainFilter(chainIdList) {
        this.chainFilter$.next(chainIdList);
        this.persistSyncStorage.set('inch-select-token_chain-filter', chainIdList);
    }
}
//# sourceMappingURL=wallet-account.context.js.map